import { useState, DependencyList } from 'react'
import useQuery from './useQuery'

const DEFAULT_OPTION = { label: '-', value: '' }

function useOptions<T>(url: string, nameCaller: string = '-', deps: DependencyList = []) {
  const [options, setOptions] = useState([DEFAULT_OPTION])
  const { fetchData, error } = useQuery<T>(url, deps)

  const loadOptions = async (
    params?: Record<string, string | number | null>,
    valueKey: string = 'code',
    labelKey: string = 'label',
    sortKey: string = 'label',
    noDefault: boolean = false,
    isPaginated: boolean = false,
    valueFormatter?: (o) => void,
    labelFormatter?: (o) => void,
  ) => {
    console.debug('Component <' + nameCaller + '> GET:: called URL = ' + encodeURI(url))
    const response = await fetchData(params)
    console.debug('..component <' + nameCaller + '> GET:: data retrieved')
    const responseData = isPaginated ? response?.data?.content : response?.data
    let options = []

    if (Array.isArray(responseData)) {
      // Apply formatters
      if (valueFormatter) {
        responseData?.forEach((it) => valueFormatter(it))
      }
      if (labelFormatter) {
        responseData?.forEach((it) => labelFormatter(it))
      }

      options =
        responseData
          ?.sort((a, b) => (a[sortKey] > b[sortKey] ? 1 : b[sortKey] > a[sortKey] ? -1 : 0))
          ?.map((obj) => ({ ...obj, value: obj[valueKey], label: obj[labelKey] })) || []
    }

    if (!noDefault && options) options = [DEFAULT_OPTION, ...options]
    setOptions(options)
  }

  return { error, fetchData, loadOptions, options }
}

export default useOptions
